export default __webpack_public_path__ + "static/media/gallery-img7.eae2dce1.jpeg";